"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_deal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "afefeaec-80e8-431c-be50-7d850d24f464",
    x1: 78.78,
    y1: 70.54,
    x2: 152.12,
    y2: 143.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2e368e7e-1574-4e63-9138-82fc152a5ade",
    x1: 48.75,
    y1: 97.48,
    x2: 49.67,
    y2: 98.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#666",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "deal-hi"), /*#__PURE__*/React.createElement("g", {
    id: "e6231610-a253-4f27-abab-436a535d0f1c",
    "data-name": "deal-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "be78653d-bcd3-4119-b78a-5b14ab9e0917",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2c95bdf4-df1a-4578-be22-efafd52aa9dd",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "461e8613-0c67-4e2f-bab4-fb857dc7ae96",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4d40ddf8-5518-42d2-8232-e31bd46008fa",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "91e9af15-bfef-4bbe-bbe5-eb445a151aac",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9a8b11ee-a966-4e03-a531-60c963593ebd",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01e24a4e-539e-412c-848b-122363f7b451",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8834b7de-7a51-49a4-8786-ffe942d779c6",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ae496f83-8079-4446-8fb8-e58ec7124eb0",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8696176f-4113-40a3-9aec-edcd62b7a27b",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "26a136ea-fc45-4000-8e27-f2411f18ccaa",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "93ad5efc-b912-468f-9141-1c4fdf257def",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6a142040-c1bd-4e7e-9cfb-d6ee430dad4e",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "659bbff5-f36a-4f97-8577-3a471ae33c97",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fe44b98a-d87a-4d37-97cc-9ebb4f4da314",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6d7a4a1f-def2-4ab0-b9f8-426d1e1e1839",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "43650828-5887-4803-a8ee-b9c3249356ea",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "89b63ce0-d69c-4f50-ac9a-456e447eaa0e",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fbf0f0b8-8526-4d35-8598-fc13956810c3",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "17aa4b9a-3b53-4642-9caa-f556039263a5",
    "data-name": "Bar_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "163d97d0-1a64-42a3-835f-72fdb349c3e4",
    "data-name": "Line_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a999d499-f477-416f-8a41-c2a54a08b4ef",
    "data-name": "Blog_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9e456726-9600-4df7-8752-655060abe585",
    "data-name": "SoHo_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "269c8b15-8f55-4e6b-9cd7-a5b3bd9864f4",
    "data-name": "SME_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1694714f-3ee5-4368-a606-8e8b8c1f21a6",
    "data-name": "Public_sector_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9f9c82f5-39da-4b19-9e83-9b6169e0259f",
    "data-name": "Extras_services_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d6635da8-a6e2-4d6b-b228-7eace57d3590",
    "data-name": "Deal_Partnership_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.7,102.24,90.86,34.63l-1.33-.77a43.16,43.16,0,0,0-59,15.8l-9.79,17a43.16,43.16,0,0,0,15.8,59l67.82,39.16a13.7,13.7,0,0,0,6.87,1.85,13.87,13.87,0,0,0,3.59-.48A13.73,13.73,0,0,0,125,153.75a13.77,13.77,0,0,0,18.28-12.06,13.79,13.79,0,0,0,17.84-16.59l0-.05a13.78,13.78,0,0,0,9.84-16.9C170.38,105.89,167.7,102.24,167.7,102.24Z",
    transform: "translate(0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.51,147.62a13.72,13.72,0,0,0,1.81-5.93,13.79,13.79,0,0,0,17.84-16.59l0-.05a13.78,13.78,0,0,0,9.84-16.9c-.6-2.24-3.28-5.89-3.28-5.89h0L121.22,75.41a23.4,23.4,0,0,1-6.52,5.16c-6.43,3.3-14.3,5.56-24.68,2L80,93.42c-6.25,6.23-19.82,9.68-25.57,7.52l-3.2-1.2a4,4,0,0,1-1.06-.59l66.38,66.38a13.69,13.69,0,0,0,8.5-11.78,13.79,13.79,0,0,0,16.47-6.13Z",
    transform: "translate(0)",
    opacity: 0.2,
    fill: "url(#afefeaec-80e8-431c-be50-7d850d24f464)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.88,97.36l-.25.25.92.92A4,4,0,0,1,48.88,97.36Z",
    transform: "translate(0)",
    fill: "url(#2e368e7e-1574-4e63-9138-82fc152a5ade)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.22,75.41l46.47,26.83a42.87,42.87,0,0,0,3.53-33,44.19,44.19,0,0,0-20.49-25.51l-16.26-9.39A43.19,43.19,0,0,0,75.54,50.1L49.26,93.84a4.18,4.18,0,0,0-.64,2,4,4,0,0,0,2.6,3.89l3.2,1.2c5.75,2.16,19.33-1.29,25.57-7.52L90,82.55c10.37,3.58,18.25,1.33,24.68-2A23.4,23.4,0,0,0,121.22,75.41Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.68,100.24,121.22,73.41a23.4,23.4,0,0,1-6.52,5.16c-6.43,3.3-14.3,5.56-24.68,2L80,91.42c-6.25,6.23-19.82,9.68-25.57,7.52l-3.2-1.2A4,4,0,0,1,48.76,95a3.62,3.62,0,0,0-.14.85,4,4,0,0,0,2.6,3.9l3.2,1.2c5.75,2.16,19.33-1.29,25.57-7.52L90,82.55c10.37,3.58,18.25,1.33,24.68-2a23.4,23.4,0,0,0,6.52-5.16l46.47,26.83A42.87,42.87,0,0,0,173,80.6,42.92,42.92,0,0,1,167.68,100.24Z",
    transform: "translate(0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.78,133.56a13.79,13.79,0,0,1-16.46,6.13h0a13.78,13.78,0,0,1-2.37-1.08L98.55,114.13c-1-.55-1.58,1.09,0,2l42.39,24.47a13.83,13.83,0,0,0,2.1,1,13.65,13.65,0,0,1-1.53,4A13.79,13.79,0,0,1,125,151.75v0a13.8,13.8,0,0,1-2.37-1.08L88.77,131.09c-1-.55-1.58,1.09,0,2l33.91,19.58a13.85,13.85,0,0,0,2.09,1,13.54,13.54,0,0,1-1.52,4,13.7,13.7,0,0,1-8.37,6.43,13.87,13.87,0,0,1-3.59.48,13.7,13.7,0,0,1-6.87-1.85L36.59,123.57A42.87,42.87,0,0,1,16.48,97.36,43.45,43.45,0,0,1,15,87.16a43.32,43.32,0,0,0,1.47,12.2,42.87,42.87,0,0,0,20.11,26.21l67.82,39.16a13.7,13.7,0,0,0,6.87,1.85,13.87,13.87,0,0,0,3.59-.48,13.77,13.77,0,0,0,10.18-12.35,13.79,13.79,0,0,0,18.27-12.06,13.78,13.78,0,0,0,18.26-14.07A13.72,13.72,0,0,1,159.78,133.56Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.41,110.67a13.79,13.79,0,0,1-20.64,11L108.35,97.17c-1-.55-1.58,1.09,0,2l42.42,24.47a13.79,13.79,0,0,0,20.64-13Z",
    transform: "translate(0)"
  })))))))))))))))))))))))))))))));
}

var _default = ic_deal;
exports.default = _default;